import { Box, Button } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect } from "react";
import { BannerCouponName, UpgradeDialogSource } from "schemas/dashboard";

import { useCheckout } from "components/StripeCheckout/useCheckout";

import BannerCloseButton from "../BannerCloseButton";
import BannerWrapper from "../BannerWrapper";
import { useCountDown } from "../useCountdown";

const NewSubscriberPromo = () => {
  const { getPromoCodeByName } = useCheckout();
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const { display, createTimer } = useCountDown();
  const promoCode = getPromoCodeByName(BannerCouponName.new_subscriber);

  useEffect(() => {
    if (promoCode) {
      createTimer(promoCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!promoCode) return <></>;

  const openUpgrade = () =>
    setUpgradeDialogSource(UpgradeDialogSource.countdown_banner);

  return display ? (
    <BannerWrapper onClick={openUpgrade}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: { xs: 1, md: 1.25 },
          fontSize: { xs: 12.5, md: 14 },
          whiteSpace: "nowrap",
        }}
      >
        <Box
          component="i"
          className="fa-solid fa-tags"
          sx={{ color: "yellow.main", fontSize: { xs: 14, md: 16 } }}
        />
        <Box component="span">
          <Box
            component="b"
            sx={{ fontWeight: 600, display: { xs: "none", md: "inline" } }}
          >
            Your exclusive {promoCode?.discountPercent}% discount
          </Box>
          <Box
            component="b"
            sx={{ fontWeight: 600, display: { xs: "inline", md: "none" } }}
          >
            {promoCode?.discountPercent}% off all plans
          </Box>
          <Box
            component="span"
            sx={{ display: { xs: "none", md: "inline" }, opacity: 0.8 }}
          >
            {" "}
            on all plans ends soon
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: "none", md: "inline-flex" },
          alignItems: "center",
          gap: 0.875,
          fontWeight: 600,
          fontVariantNumeric: "tabular-nums",
          backgroundColor: "rgba(255,255,255,0.1)",
          border: "1px solid rgba(255,255,255,0.14)",
          borderRadius: "999px",
          px: 1.5,
          py: 0.5,
          fontSize: 13,
        }}
      >
        <Box
          component="i"
          className="fa-solid fa-clock"
          sx={{ color: "yellow.main", fontSize: 13 }}
        />
        {display}
      </Box>

      <Button
        onClick={openUpgrade}
        disableElevation
        sx={{
          backgroundColor: "yellow.main",
          color: "green.dark",
          fontWeight: 600,
          fontSize: { xs: 12, md: 13 },
          borderRadius: "999px",
          px: { xs: 1.5, md: 2.25 },
          py: 0.625,
          textTransform: "none",
          whiteSpace: "nowrap",
          minWidth: "auto",
          "&:hover": {
            backgroundColor: "yellow.main",
            filter: "brightness(0.93)",
          },
        }}
      >
        Upgrade Now
      </Button>

      <BannerCloseButton />
    </BannerWrapper>
  ) : (
    <></>
  );
};

export default NewSubscriberPromo;
